/** Keeps the first item for each key. */
export function uniqueBy<T>(arr: T[], key: keyof T | ((item: T) => unknown)): T[] {
    const uniqueArray: T[] = [];
    const uniqueKeys = new Set<unknown>();

    for (const obj of arr) {
        const keyValue = typeof key === 'function' ? key(obj) : obj[key];
        if (!uniqueKeys.has(keyValue)) {
            uniqueKeys.add(keyValue);
            uniqueArray.push(obj);
        }
    }

    return uniqueArray;
}
